import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const AFTER_EFFECTS_COMPOSITION_ACTIONS = {
	GET_AE_COMPOSITIONS_AJAX: "GET_AE_COMPOSITIONS_AJAX",
	GET_AE_COMPOSITIONS_SUCCESS: "GET_AE_COMPOSITIONS_SUCCESS",
	GET_AE_COMPOSITIONS_ERROR: "GET_AE_COMPOSITIONS_ERROR",
	CLEAR_AE_COMPOSITIONS: "CLEAR_AE_COMPOSITIONS",
};

const initialState = {
	items: [],
	error: null,
	isLoading: false,
	packageId: null,
};

export function getAECompositions(libraryId, packageId) {
	return (dispatch) => {
		return dispatch({
			type: AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			payload: {
				packageId,
			},
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/after-effects/${packageId}/compositions`,
				success: AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_SUCCESS,
				error: AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_ERROR,
			},
		});
	};
}

export function clearCompositions() {
	return (dispatch) => {
		return dispatch({
			type: AFTER_EFFECTS_COMPOSITION_ACTIONS.CLEAR_AE_COMPOSITIONS,
		});
	};
}

export const handlers = {
	[AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_AJAX]: getAECompositionsRequest,
	[AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_SUCCESS]: getAECompositionsSuccess,
	[AFTER_EFFECTS_COMPOSITION_ACTIONS.GET_AE_COMPOSITIONS_ERROR]: getAECompositionsError,
	[AFTER_EFFECTS_COMPOSITION_ACTIONS.CLEAR_AE_COMPOSITIONS]: reset,
};

function getAECompositionsRequest(state, action) {
	return {
		...state,
		isLoading: true,
	};
}

function getAECompositionsSuccess(state, action) {
	return {
		...state,
		items: action.payload?.data.compositions || [],
		packageId: action.payload?.original?.packageId || null,
		isLoading: false,
	};
}

function getAECompositionsError(state, action) {
	let { errorObj } = action.payload;
	if(typeof errorObj !== 'object'){
		errorObj = {
			description: action.payload.error?.message,
			code: action.payload.error?.response?.status,
		};
	}
	return {
		...state,
		isLoading: false,
		error: errorObj,
	};
}

function reset(state, action) {
	return {
		...initialState,
	};
}

let reducerConfig = {
	typeRoot: "AFTER_EFFECTS_COMPOSITIONS",
	actionTypes: AFTER_EFFECTS_COMPOSITION_ACTIONS,
	actionCreators: {
		clearCompositions,
		getAECompositions,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, {});
reducerConfig = addColumnFilters(reducerConfig, {});

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const AfterEffectsCompositions = reducerConfig.actionCreators;
